import React, { useState, useEffect } from "react";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import "./App.css";
import "../src/css/Dashboard.css";
import "../src/fonts/Fonts.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AddCustomer from "./components/AddCustomer";
import CustomerPage from "./pages/Customers";
import Orders from "./pages/Orders";
import Quotes from "./pages/Quotes";
import AddQuotes from "./components/AddQuote";
import CustomerDetailPage from "./components/CustomerDetail";
import AddOrder from "./components/AddOrder";
import EditOrder from "./components/EditOrder";
import Invoice from "./pages/Invoice";
import OrderPreview from "./pages/OrderPreview";
import ReviewPage from "./components/ReviewOrder";
import EditQuote from "./components/EditQuote";
import Settings from "./pages/Settings"
import EditCustomer from "./components/EditCustomer"
import CustomerDetailPdf from "./components/Customer_pdf";
import EditInvoice from "./components/EditInvoice"




function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const savedLoginState = localStorage.getItem("isLoggedIn");
    if (savedLoginState === "true") {
      setIsLoggedIn(true);
    }
  }, []);

   useEffect(() => {
    const handleWheel = () => {
      const active = document.activeElement;

      if (active && active.tagName === "INPUT" && active.type === "number") {
        active.blur(); // remove focus → prevents value change
      }
    };

    window.addEventListener("wheel", handleWheel);

    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);


  return (
    <div>
      <BrowserRouter>
         

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/quotes" element={<Quotes />} />
          <Route path="/add-customer" element={<AddCustomer />} />
          <Route path="/customers" element={<CustomerPage />} />
          <Route path="/customer-detail/:id" element={<CustomerDetailPage />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/add-order/:customer_id" element={<AddOrder />} />
          <Route path="/quotes/new-quote/:customer_id" element={<AddQuotes />} />
          <Route path="/new-invoice/:id" element={<Invoice />} />
          <Route path="/order-preview/:order_id" element={<OrderPreview />} />
          <Route path="/edit-order/:order_id" element={<EditOrder />} />
          <Route path="/edit-invoice/:id" element={<EditInvoice />} />
          <Route path="/review-order" element={<ReviewPage />} />
          <Route path="/edit-quote/:quote_id" element={<EditQuote />} />
          <Route path="/edit-customer/:id" element={<EditCustomer />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/customer-pdf" element={<CustomerDetailPdf />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default App;
